import React, { Component } from 'react'
import Select from 'react-select'

class MovementFromTo extends Component {
    constructor() {
        super()
        this.state = {
            movementFromToList:[ {"label":"From My Kitchen","value":"From"},{"label":"To My Kitchen","value":"To"}]
        }
        this.isComponentStillMounted = true
    }

   

    componentWillUnmount() {
        this.isComponentStillMounted = false
    }

    

    render() {
       return (
            <div>
                <Select
                value={this.props.selectedValue}
                options={this.state.movementFromToList}
                placeholder="Select Movement"
                onChange={(e) => { (e) ? this.props.movementFromToChange(e) : this.props.movementFromToChange([])}}
                />
            </div>
        )
    }
}

export default MovementFromTo


// WEBPACK FOOTER //
// ./src/modules/Employees Movement/Components/DropDowns/MovementFromTo.js